import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderUserOutline = createIcon({
  displayName: 'FolderUserOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20 19l-.284-.713c-.144-.361-.367-.686-.652-.95v0c-.483-.448-1.118-.696-1.776-.696h-3.924"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21 12v-4.06c0-1.104-.895-2-2-2h-6.471c-.331 0-.641-.164-.827-.438l-1.405-2.065c-.186-.273-.495-.437-.826-.437h-4.471c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h5"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16.667 10.159c.879.879.879 2.303 0 3.182 -.879.879-2.303.879-3.182 0 -.879-.879-.879-2.303 0-3.182 .879-.879 2.303-.879 3.182 0"
        ></path>
      </g>
    </>
  ),
})

const FolderUser: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderUserTwoTone} {...props} />

  return <CustomIcon as={FolderUserOutline} {...props} />
}

export default memo(FolderUser)
